import Service from 'react-reservice';

import configs from '@aqx-core/common/configs';

export interface IConfigServiceContext {
  currentApiDomain: string;
  currentStaticDomain: string;
  apiResponseError?: string;
}

const defaultContext: IConfigServiceContext = {
  currentApiDomain: configs.apiDomain || configs.baseURL || '',
  currentStaticDomain: configs.staticDomain || configs.baseURL || '',
  apiResponseError: undefined
};

class ConfigService extends Service<IConfigServiceContext> {
  constructor() {
    super();
    this.context = defaultContext;
  }

  public setCurrentApiDomain = (currentApiDomain: string) => {
    this.context.currentApiDomain = currentApiDomain;
  };

  public setCurrentStaticDomain = (currentStaticDomain: string) => {
    this.context.currentStaticDomain = currentStaticDomain;
  };

  public setApiResponseError = (error: string) => {
    this.context.apiResponseError = error;
  };
}

export const configService = new ConfigService();
